import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cscancellation',
  templateUrl: './cscancellation.component.html',
  styleUrls: ['./cscancellation.component.css']
})
export class CscancellationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
